'use client'

import { createContext, type ReactNode, useContext, useState } from 'react'

interface IHeaderContext {
  label: string
  setLabel: (label: string) => void
}

export const HeaderContext = createContext<IHeaderContext>({
  label: '',
  setLabel: () => null,
})

export const HeaderContextProvider = ({ children }: { children: ReactNode }) => {
  const [label, setLabel] = useState('')

  return <HeaderContext.Provider value={{ label, setLabel }}>{children}</HeaderContext.Provider>
}

export const useHeaderContext = () => {
  const context = useContext(HeaderContext)

  if (!context) {
    throw new Error('useHeaderContext must be used within a HeaderContextProvider')
  }

  return context
}
